import React, { useState } from 'react';

import { Input } from 'antd';

import styled from 'styled-components';

import BookerSelector from '@components/BookerSelector/BookerSelector';
import { NwAddButton } from '@components/Gui/NwButton';

import { useShowSeasonContext } from './ShowSeasonContext';

const Wrapper = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 2rem;
    min-height: 5rem;
    padding: 0.25rem 0;
    width: auto;
`;

const FieldBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: auto;
    flex-shrink: 0;
`;

const FieldLabel = styled.small`
    display: block;
    margin-bottom: 0.15rem;
    text-transform: uppercase;
    color: ${(props) => props.theme.TextColorMuted};
    font-size: ${(props) => props.theme.FontSizeSm};
`;

const StopPropagation = styled.div`
    width: auto;
`;

const ShowSeasonModelsTableColumn = ({ model }) => {
    const { seasonModelIdSet, onAddModel } = useShowSeasonContext();
    const [notes, setNotes] = useState('');
    const [bookerId, setBookerId] = useState(undefined);

    const isAdded = seasonModelIdSet.has(model.ID);

    const handleAdd = () => {
        onAddModel({
            modelId: model.ID,
            notes: notes.trim(),
            bookerId: bookerId || null,
        });
        setNotes('');
        setBookerId(undefined);
    };

    const stopRowClick = (event) => {
        event.stopPropagation();
    };

    if (isAdded) {
        return (
            <Wrapper>
                <FieldBlock>
                    <NwAddButton primary disabled label="Added" onClick={() => {}} />
                </FieldBlock>
            </Wrapper>
        );
    }

    return (
        <Wrapper onClick={stopRowClick} onMouseDown={stopRowClick}>
            <FieldBlock>
                <FieldLabel>Booker</FieldLabel>
                <StopPropagation>
                    <BookerSelector value={bookerId} onChange={setBookerId} disableClosable onlyActive />
                </StopPropagation>
            </FieldBlock>
            <FieldBlock>
                <FieldLabel>Note</FieldLabel>
                <Input
                    allowClear
                    placeholder="Add a note"
                    value={notes}
                    onChange={(event) => setNotes(event.target.value)}
                    onClick={stopRowClick}
                />
            </FieldBlock>
            <FieldBlock>
                <NwAddButton primary label="Add" onClick={handleAdd} />
            </FieldBlock>
        </Wrapper>
    );
};

export default ShowSeasonModelsTableColumn;
